// app.price-lists._index.tsx (list/create) + app.price-lists.$id.tsx (single
// price list editor: entries, currency-change guard, archive/restore).
export const priceLists = {
  pageHeading: "Price lists",
  status: {
    ACTIVE: "Active",
    ARCHIVED: "Archived",
  },
  actions: {
    archive: "Archive",
    restore: "Restore",
  },
  form: {
    nameLabel: "Name",
    currencyLabel: "Currency code",
  },
  createSection: {
    heading: "Create a price list",
    description:
      "Set fixed B2B prices per product variant, then assign the list to a company. New quotes for that company prefill each line from the list — you can still override any line.",
    namePlaceholder: "e.g. Wholesale 2026",
    submitButton: "Create price list",
  },
  list: {
    heading: "Your price lists ({{count}})",
    hideArchived: "Hide archived",
    showArchived: "Show archived",
    empty: "No price lists yet. Create one above to start offering negotiated B2B pricing.",
    variantCountOne: "{{count}} variant",
    variantCountOther: "{{count}} variants",
    companyCountOne: "{{count}} company",
    companyCountOther: "{{count}} companies",
    updated: "Updated {{date}}",
  },
  errors: {
    nameRequired: "Enter a name for the price list.",
    createFailed: "Could not create price list.",
    missingId: "Missing price list id.",
    notFound: "Price list not found.",
    nameRequiredSave: "Name is required.",
    entriesInvalid: "Entries payload invalid.",
    tooManyEntries: "Price list exceeds 5000 entries.",
    invalidPrice: "Invalid price for {{title}}.",
    entryMustReferenceVariant: "Each entry must reference a product variant.",
    currencyChangeWarning:
      'Changing the currency from {{from}} to {{to}} does NOT convert existing prices — every amount will be re-interpreted as {{to}}. Check "I understand" below to confirm, or keep the currency as {{from}}.',
    saveFailed: "Could not save price list.",
  },
  edit: {
    heading: "Edit price list",
    pickerUnavailable: "Resource picker is unavailable. Open this app from inside Shopify admin.",
    archivedBanner: "This price list is archived — it no longer prefills new quotes. Restore it to use it again.",
    assignmentBannerOne:
      "Assigned to {{count}} company. Editing prices here changes the prefill for their future quotes (existing quotes are unaffected).",
    assignmentBannerOther:
      "Assigned to {{count}} companies. Editing prices here changes the prefill for their future quotes (existing quotes are unaffected).",
    detailsHeading: "Details",
    currencyChangeNotice:
      "Changing the currency does not convert existing prices — every amount is re-interpreted under the new currency, not recalculated.",
    confirmCurrencyCheckbox: "I understand — change the currency without converting prices",
    variantsHeading: "Variant prices ({{count}})",
    noVariantsBody: 'No variants yet. Click "Add products" to choose variants and set their fixed prices.',
    skuLabel: "SKU {{sku}}",
    priceFieldLabel: "{{currency}} price",
    removeButton: "Remove",
    addProductsButton: "Add products",
    addMoreProductsButton: "Add more products",
    saveButton: "Save price list",
    statusHeading: "Status",
    archiveButton: "Archive price list",
    restoreButton: "Restore price list",
  },
};
